import {makeLocalStorageAdapter} from 'main/factories/cache/local-storage-adapter-factory';
import {FEATURE_FLAGS_STORAGE_KEY} from './fetch-feature-flag/constants';

export function clearLocalStorageFeatureFlags() {
	makeLocalStorageAdapter().set(FEATURE_FLAGS_STORAGE_KEY);
}
